// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QLzO","rootMobile":"styles_rootMobile__2xQwT"};